<template>
  <div class="commission-details" ref="container">
    <div class="my-promotion">
      <div class="header">
        <div class="name acea-row row-center-wrapper">
          <div>当月销售额</div>
        </div>
        <div class="num">{{ info.thisMonth }}</div>
        <div class="profit acea-row row-between-wrapper">
          <div class="item">
            <div>上月销售额</div>
            <div class="money">{{ info.lastMonth }}</div>
          </div>
          <div class="item">
            <div>累计积分</div>
            <div class="money">{{ info.integral }}</div>
          </div>
        </div>
      </div>
      <div class="bnt bg-color-red" @click="toJoin" v-if="info.isjoin == 0">
        立即参加
      </div>
      <div class="bnt bg-color-yellow" v-if="info.isjoin == 1">已参加</div>
    </div>
    <div class="sign-record" ref="content">
      <div class="list">
        <div class="item" v-for="(item, index) in list" :key="index">
          <div class="listn">
            <div class="itemn acea-row row-between-wrapper">
              <div>
                <div class="name line1">{{ item.add_time }}</div>
                <div>完成额度：{{ item.salsecount }}</div>
              </div>
              <div class="num dpnum" :class="statusClass(item.status)">
                {{ item.status_txt }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Loading :loaded="loaded" :loading="loading"></Loading>
  </div>
</template>

<script>
import {
  getMilitaryOrderInfo,
  getMilitaryOrderList,
  militaryOrderJion
} from "../../api/user";
import Loading from "@components/Loading";

export default {
  name: "UserMilitaryOrder",
  components: {
    Loading
  },
  props: {},
  data: function() {
    return {
      info: {},
      list: [],
      where: {
        page: 1,
        limit: 10
      },
      thisMonth: "0",
      loaded: false,
      loading: false
    };
  },
  mounted: function() {
    this.getinfo();
    this.getIndex();
    this.$scroll(this.$refs.container, () => {
      this.loading === false && this.getIndex();
    });
  },
  methods: {
    getIndex: function() {
      let that = this;
      if (that.loading == true || that.loaded == true) return;
      that.loading = true;
      getMilitaryOrderList(that.where).then(
        res => {
          that.loading = false;
          that.loaded = res.data.length < that.where.limit;
          that.loadTitle = that.loaded ? "人家是有底线的" : "上拉加载更多";
          that.where.page = that.where.page + 1;
          that.list.push.apply(that.list, res.data);
        },
        error => {
          that.$dialog.message(error.msg);
        }
      );
    },
    getinfo: function() {
      let that = this;
      getMilitaryOrderInfo().then(
        res => {
          that.$set(that, "info", res.data);
        },
        error => {
          that.$dialog.message(error.msg);
        }
      );
    },
    toJoin: function() {
      let that = this;
      //this.$router.push({ path: "/user/user_cash" });
      militaryOrderJion().then(
        res => {
          if (res.status == "400") {
            that.$dialog.message(res.msg);
          } else if (res.status == "200") {
            that.$set(that.info, "isjoin", 1);
            that.$dialog.message("参加成功！");
          }
        },
        error => {
          that.$dialog.message(error.msg);
        }
      );
    },
    statusClass: function(status) {
      var classname = "";
      switch (status) {
        case 0: //进行中
          classname = "font-color-red";
          break;
        case 1: //已完成
          classname = "font-color-blue";
          break;
        case 2: //未完成
          classname = "font-color-gray";
          break;
        default:
          classname = "";
      }
      return classname;
    }
  }
};
</script>
<style scoped>
.sign-record .list .item .listn .itemn .num {
  font-size: 0.26rem;
}
</style>
